import React, {useState} from 'react';
import { FaBars } from 'react-icons/fa'
import Logo from '../../../images/logo.png'
import { 
	Nav,
	NavbarContainer,
	NavLogo,
	MobileIcon,
	NavMenu,
	NavItem,
	NavLinks
} from './NavbarElements';
import "../../../App.css"
import { useTranslation } from 'react-i18next';

const Navbar = ({toggle}) => {
	const {t, i18n} = useTranslation();
  function handleClick(lang){
    
    window.location.reload(i18n.changeLanguage(lang))

  }

  const [navbar, setNavbar] = useState(false);
  const changeBackground = () => {
    if(window.scrollY >= 80) {
      setNavbar(true)
    } else{
      setNavbar(false);
    }
  }
  window.addEventListener("scroll", changeBackground)
	return (
		<>
			<Nav className={navbar ? 'navbar active' : Nav}>
				<NavbarContainer>
					<NavLogo to='/'><img src={Logo}  alt='' style={{width: '134px'}}/></NavLogo>
					<MobileIcon onClick={toggle}>
						<FaBars/>
					</MobileIcon>
					<NavMenu>
						<NavItem>
							<NavLinks to="/notice">{t("issue")}</NavLinks>
						</NavItem>
						<NavItem>
							<NavLinks to="/user/faq">FAQ</NavLinks>
						</NavItem>
						<NavItem>
							<NavLinks to="/" style={{marginRight: "6rem"}}>LOG IN</NavLinks>
						</NavItem>
            <button className='glow-on' onClick={()=> handleClick('en')}>English</button>
            <button className='glow-on' onClick={()=> handleClick('ko')}>한국어</button>
					</NavMenu>
				</NavbarContainer>
			</Nav>		
		</>
	)
}

export default Navbar;
